export default __webpack_public_path__ + "static/media/Setting.30edf3e1.svg";